import { HistoricalChartButtonComponent } from "./components/historical-chart-button.component";
import { IndicatorLastPriceComponent } from "./components/indicators-last-price.component";
import { LastPriceComponent } from "./components/last-price.component";
import { TiChartSeriesComponent } from "./components/ti-chart-series.component";
import { TILogoComponent } from "./components/ti-logo.component";
import { BaseChartContainer } from "./models/base/base-chart.container";
import { IChartContainer } from "./models/base/chart-container.interface";
import { ChartStyleSettingsModel } from "./models/chart-style/chart-style-settings.model";
import { ScrollMode } from "./models/enum/scroll-mode.enum";
import { WebChartDataService } from "./services/web-chart-data.service";
import { TiChartMenuContainer } from "./ti-chart-menu.container";

export class WebChartsMarketingPnpContainer extends BaseChartContainer {

    public override chartService: WebChartDataService = null as any;

    private tiChartMenu: TiChartMenuContainer | null = null;

    private baseChart: IChartContainer;
    private pnpSwitchElement: HTMLElement | null = null;
    
    constructor(element: HTMLElement, baseElement: HTMLElement, baseChart: IChartContainer) {
        super();

        this.baseChart = baseChart;
        this.element = element;

        if (!this.element) {
            return;
        }
        
        this.id = baseChart.id + '-pip';

        this.element.addClass(this.id);
        
        this.element.findFirst('span.base-path').ifExistThen((el: HTMLElement) => {
            this.basePath = el.innerHTML;
            el.remove();
        });
        
        this.setPnPSize();

        this.marketingWebChartMode = true;
        this.pnpMode = true;
        this.chartService = new WebChartDataService(this, baseElement);
        // this.drawingToolsManager = new DrawingToolsManager(this);

        const chartMenuElement = this.element.findFirst('.chart-menu-box');
        if (chartMenuElement == null) {
            console.error('ERROR: .chart-menu-box element not found, html needs to be udpated')
            return;
        }

        this.pnpSwitchElement = baseChart.getPnPSwitchElement();
        this.chartService.subscribeChartStyleData((chartStyle: ChartStyleSettingsModel) => {
            if (chartStyle.pnpEnabled) {
                this.element.removeClass('hidden');
                this.pnpSwitchElement?.removeClass('hidden');
            } else if (!chartStyle.pnpEnabled) {
                this.element.addClass('hidden');
                this.pnpSwitchElement?.addClass('hidden');
            }
        });
        
        //Note: the menu needs to be created before the chart series, since HighChart Indicators calls IndicatorLastPrice
        this.tiChartMenu = new TiChartMenuContainer(chartMenuElement, this);

        this.createTIChartSeriesComponent();
        this.createIndicatorsLastPriceComponent();
        this.createLastPriceComponent();
        this.createTILogoComponent();
        this.createHistoricalChartButtonComponent();
        this.setPnPLeftPosition();

        this.onArrowOnOffClick();
        this.onResize();
        this.onDblClick();
        this.onDrag();
    }

    public subscribeLogin() {
        const chartService = this.chartService as WebChartDataService;
        chartService.connection.subcribeToLoginEvent(() => {
            chartService.onLoggedIn();
        })
    }

    private createTIChartSeriesComponent() {
        this.tiChartSeries = new TiChartSeriesComponent(this.element, this);
        this.components.push(this.tiChartSeries);
    }

    private createLastPriceComponent() {
        this.element.querySelectorAll<HTMLElement>('.main-symbol-last-price').forEach((el: HTMLElement) => {
            this.components.push(new LastPriceComponent(el, this));
        });
    }

    private createIndicatorsLastPriceComponent() {
        this.element.querySelectorAll<HTMLElement>('.indicator-last-prices').forEach((el: HTMLElement) => {
            this.components.push(new IndicatorLastPriceComponent(el, this));
        });
    }

    private createTILogoComponent() {
        this.element.querySelectorAll<HTMLElement>('.logo-wrapper').forEach((el: HTMLElement) => {
            this.components.push(new TILogoComponent(el, this));
        });
    }

    private createHistoricalChartButtonComponent() {
        this.element.querySelectorAll<HTMLElement>('.historical-chart-button').forEach((el: HTMLElement) => {
            this.components.push(new HistoricalChartButtonComponent(el, this));
        });
    }

    private alreadyCickedCollapse = false;
    private onArrowOnOffClick() {
        const arrows = this.element.querySelectorAll<HTMLElement>('.pnp-on-off-arrow .arrow');
        arrows.forEach((el: HTMLElement) => {
            el.addEventListener('click', (e: MouseEvent) => {
                e.preventDefault();

                this.element.style.transition = 'left ease-in-out 1s';
                arrows.forEach((a: HTMLElement) => {
                    a.addClass('hidden');
                });

                
                this.element.classList.toggle('show');
                if (!this.element.classList.contains('show')) {
                    this.alreadyCickedCollapse = true;
                }

                this.setPnPLeftPosition();
                setTimeout(() => {
                    this.element.style.transition = '';
                    arrows.forEach((a: HTMLElement) => {
                        a.removeClass('hidden');
                    });
                }, 1000);
            });
        });
    }

    public setPnPSize() {
        const mainChartElementWidth = this.baseChart.element.clientWidth;
        const mainChartElementHeight = this.baseChart.element.clientHeight;
        let width = mainChartElementWidth / 3;
        let height = mainChartElementHeight / 3;
        
        if (width < 210) {
            width = 210;
        } 

        if (height < 140) {
            height = 140;
        }

        const newHeight = height + 'px';
        this.element.style.width = width + 'px';
        this.element.style.height = newHeight;
        
        if (this.element.style.top != '45px') {
            this.element.style.top = 'calc(100% - ' + newHeight + ')';
        }

        // Auto Collapse PIP on small chart:
        // Make the PIP minimum width 210. If the Main chart width goes below 2x that width (420), then collapse the PIP
        // Make the PIP minimum height 140. If the Main chart height goes below 2x that height (280), then collapse the PIP
        const widowWidth = this.body.clientWidth;
        const windowHeight = this.body.clientHeight;

        if (widowWidth >= 420 && windowHeight >= 280) {
            if (!this.alreadyCickedCollapse) {
                this.element.addClass('show');
            }
            this.pnpSwitchElement?.display();
        } else {
            this.element.removeClass('show');
            this.pnpSwitchElement?.hide();
        }
        
        this.setPnPLeftPosition();

        setTimeout(() => {
            this.tiChartSeries?.highStockChart?.reflow();
        }, 320);
    }

    private setPnPLeftPosition() {
        if (this.element.classList.contains('right')) {
            if (!this.element.classList.contains('show')) {
                this.element.style.left = '100%';
            } else {
                this.element.style.left = `calc(100% - ${this.element.style.width})`;
            }
        } else {
            if (!this.element.classList.contains('show')) {
                const width = parseInt(this.element.style.width.replace('px', ''), 10);
                this.element.style.left = '-' + width + 'px';
            } else {
                let extraLeft = 0;
                this.element.style.left = extraLeft + 'px';
            }
        }
    }

    private onDblClick() {
        this.element.addEventListener('dblclick', () => {
            const baseChart = this.baseChart as any;
            baseChart.pnpSwitchComponent?.togglePnPMode();
            baseChart.pnpSwitchComponent?.requestTimeFrame();
        });
    }

    private onDrag() {
        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        let dragStart = false;

        this.element.addEventListener('mousedown', (e: MouseEvent) => {
            const targetElement = e.target as HTMLElement;
            if (dragStart || targetElement.classList.contains('arrow') || targetElement.closest('.pnp-on-off-arrow')) {
                return;
            }

            if (this.baseChart.disableScrolling && this.baseChart.scrollMode == ScrollMode.ClickAndDrag 
                && !targetElement.classList.contains('menu-box')) {
                return;
            }

            dragStart = true;

            pos3 = e.clientX;
            pos4 = e.clientY;

            this.element.addClass('dragging');
        });

        this.body.addEventListener('mousemove', (e: MouseEvent) => {
            if (!dragStart) {
                return;
            }

            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            this.element.style.left = (this.element.offsetLeft - pos1) + 'px';
            this.element.style.top = (this.element.offsetTop - pos2) + 'px';
        });        
        
        this.body.addEventListener('mouseleave', () => {
            if (!dragStart) {
                return;
            }

            dragStart = false;
            this.setPnPPositionAfterDrag();
            console.log('drop')
        });

        this.body.addEventListener('mouseup', () => {
            if (!dragStart) {
                return;
            }

            dragStart = false;
            this.setPnPPositionAfterDrag();
            console.log('drop')
        });
    }

    private setPnPPositionAfterDrag() {
        this.element.removeClass('dragging');

        const bodyWidth = this.baseChart.element.clientWidth;
        const bodyHeight = this.baseChart.element.clientHeight;

        this.element.style.transition = 'all ease-in-out 1s';
        setTimeout(() => {
            this.element.style.transition = '';
        });

        if (bodyWidth / 2 < this.element.offsetLeft) {
            this.element.addClass('right');
            if (bodyHeight / 2 < this.element.offsetTop) {
                this.element.style.left = `calc(100% - ${this.element.style.width})`;
                this.element.style.top = `calc(100% - ${this.element.style.height})`;
            } else {
                this.element.style.left = `calc(100% - ${this.element.style.width})`;
                this.element.style.top = `45px`;
            }
        } else {
            this.element.removeClass('right');
            if (bodyHeight / 2 < this.element.offsetTop) {
                this.element.style.left = '0px';
                this.element.style.top = `calc(100% - ${this.element.style.height})`;
            } else {
                this.element.style.left = '0px';
                this.element.style.top = `45px`;
            }
        }
    }

    private resizeTimmer = null as any;
    private onResize() {
        this.domEvents.onResize(() => {
            clearTimeout(this.resizeTimmer);
            this.resizeTimmer = setTimeout(() => {
                if (this.baseChart.isPreview) {
                    return;
                }
                
                this.setPnPSize();
                // this.tiChartSeries.start();
            }, 150);
        });
    }
}